/* src/app/components/ComingSoonPage/styles.js */

export default () => ({
  fillPage: {
    position: 'absolute',
    backgroundColor: '#eee',
    display: 'flex',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.7,
    zIndex: 2500,
  },
  text: {
    fontSize: 100,
    marginTop: 250,
    fontWeight: 'bold',
    color: '#ccc',
  },
});



// WEBPACK FOOTER //
// ./src/app/components/ComingSoonPage/styles.js